"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcFillPageDot = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("circle", { cx: 10, cy: 10, r: 2 }) })));
exports.default = IcFillPageDot;
